import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useAsync } from "@utils/hooks";
import { Button } from "@ui/components/buttons/button";
import { ErrorContainer } from "@ui/components/containers/errorContainer";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { gap } from "@ui/styles/utils";
import { OnboardingDisconnect } from "./common";

export const ProfileNames: React.FC = () => {
	const { currentProfileService, authService } = useServices();
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [fieldError, setFieldError] = useState("");
	const { run, loading } = useAsync(async () => {
		const user = authService.firebaseUser.get();
		if (user?.phoneNumber && !user.email) {
			await currentProfileService.loginWithPhoneNumber(user.phoneNumber, firstName.trim(), lastName.trim());
			return;
		}
		if (user?.email) {
			await currentProfileService.createProfile(user.email, firstName.trim(), lastName.trim(), true);
		}
	}, [firstName, lastName]);

	return (
		<Form
			onSubmit={(event) => {
				event.preventDefault();
				if (!firstName.trim() || !lastName.trim()) {
					setFieldError(I18n.t("form.missing"));
					return;
				}
				void run();
			}}
		>
			<Title>{I18n.t("auth.names.title")}</Title>
			<Lead>{I18n.t("auth.names.lead")}</Lead>
			<Field>
				<Label htmlFor="profile-first-name">{I18n.t("register.firstName.placeholder")}</Label>
				<SimpleTextInput
					id="profile-first-name"
					value={firstName}
					onChange={(value) => {
						setFirstName(value);
						setFieldError("");
					}}
					placeholder={I18n.t("register.firstName.placeholder")}
					autoComplete="given-name"
				/>
			</Field>
			<Field>
				<Label htmlFor="profile-last-name">{I18n.t("register.lastName.placeholder")}</Label>
				<SimpleTextInput
					id="profile-last-name"
					value={lastName}
					onChange={(value) => {
						setLastName(value);
						setFieldError("");
					}}
					placeholder={I18n.t("register.lastName.placeholder")}
					autoComplete="family-name"
				/>
			</Field>
			{fieldError && <ErrorContainer>{fieldError}</ErrorContainer>}
			<Button variant="primary" size="lg" block loading={loading} type="submit">
				{I18n.t("auth.signup.continue")}
			</Button>
			<Disconnect>
				<OnboardingDisconnect />
			</Disconnect>
		</Form>
	);
};

const Form = styled.form`
	${gap(16)};
	width: 100%;
`;

const Title = styled.h1`
	margin: 0 0 6px;
	font-size: 28px;
	font-weight: 700;
	letter-spacing: -0.4px;
	line-height: 1.2;
	color: #13131a;
`;

const Lead = styled.p`
	margin: 0 0 8px;
	color: #8a94a4;
	font-size: 15px;
	line-height: 1.5;
`;

const Field = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
`;

const Label = styled.label`
	font-size: 13.5px;
	font-weight: 500;
	color: #5b6272;
`;

const Disconnect = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 8px;
`;
